import { useState } from "react";
import { useSelector } from "react-redux";
import { createEvent, createJob, getWorkForces, patchJobsById } from "../../../../utils";

export const useJobCreate = () => {
  const token = sessionStorage.getItem("token");
  const { companies } = useSelector((state) => state.userState);
  const [company] = companies;

  const [workForces, setWorkForces] = useState();
  const [loading, setLoading] = useState(false);

  const getWorkforceForRender = async () => {
    try {
      const data = await getWorkForces(token, company?.id);
      setWorkForces(data);
    } catch (error) {
      console.error(error);
    }
  };

  const createJobWithQuote = async (payload) => {
    setLoading(true);
    try {
      if (!token) {
        throw new Error("Token is missing. Please log in again.");
      }
      console.log("createJobWithQuote - Token exists:", !!token);
      console.log("createJobWithQuote - Payload:", payload);
      const res = await createJob(token, payload);
      console.log("createJobWithQuote - Response:", res);
      return res.data;
    } catch (error) {
      console.error("Error creating job:", error.response?.data || error.message);
      console.error("Error stack:", error.stack);
      throw error;
    } finally {
      setLoading(false);
    }
  };

  const assignWorkForceInJob = async (jobId, payload) => {
    setLoading(true);
    try {
      const data = await patchJobsById(token, jobId, payload);
      return data;
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const createJobEvent = async (payload) => {
    setLoading(true);
    try {
      const res = await createEvent(payload);
      console.log("event result");
      console.log(res);
      return res.data;
    } catch (error) {
      console.error("Error creating event:", error.response?.data || error.message);
      throw error;
    } finally {
      setLoading(false);
    }
  };

  return {
    // Actions
    getWorkforceForRender,
    createJobWithQuote,
    assignWorkForceInJob,
    createJobEvent,
    // Data
    workForces,

    // Estado
    loading,
  };
};
